import type { Translation } from "../i18n-types";
import home from "./home";
import contact from "./contact";
import countries from "./countries";
import about from "./about";
import software from "../en/software";

const pl = {
	home,
	contact,
	about: about as never,
	software: software as never,
	countries,
	docs: {
		title: "Dokumentacja",
		description:
			"Odkryj moc Dextera dzięki naszej dokumentacji. Naucz się, jak używać Dextera i jak zintegrować go z własnym przepływem pracy i oprogramowaniem.",
		pages: "Strony",
		toc: "Na tej stronie",
	},
	blog: {
		title: "Blog",
		description:
			"Blog Lean Customs. Bądź na bieżąco z najnowszymi wiadomościami i aktualizacjami. Zdobywaj informacje na temat ceł i logistyki.",
	},
	meta: {
		title: "Lean Customs",
	},
	actions: {
		add: "Dodaj",
		allocate: "Przydziel",
		back: "Wstecz",
		calculate: "Oblicz",
		cancel: "Anuluj",
		clear: "Wyczyść",
		close: "Zamknij",
		copy: "Kopiuj",
		create: "Utwórz",
		credit: "Kredytowanie",
		delete: "Usuń",
		download: "Pobierz",
		edit: "Edytuj",
		filter: "Filtruj",
		forward: "Przekaż dalej",
		invoice: "Faktura",
		merge: "Scal",
		next: "Następny",
		open: "Otwórz",
		prev: "Poprzedni",
		reset: "Resetuj",
		save: "Zapisz",
		search: "Szukaj",
		select: "Wybierz",
		share: "Udostępnij",
		skip: "Pomiń",
		submit: "Prześlij",
		sync: "Synchronizuj",
	},
	actions_param: {
		add: "Dodaj {0}",
		change: "Zmień {0}...",
		current: "Aktualny {0}",
		edit: "Edytuj {0}",
		goto: "Przejdź do {0}",
		new: "Nowy {0}",
	},
	common: {
		active: "Aktywny",
		all: "Wszystkie",
		general: "Ogólny",
		modified: "Zmodyfikowany",
		other: "Inny",
		copied: "Skopiowany",
	},
	locales: {
		bg: "Bułgarski",
		de: "Niemiecki",
		en: "Angielski",
		fr: "Francuski",
		nl: "Holenderski",
		pl: "Polski",
	},
	messages: {
		confirm_deletion: "Czy na pewno chcesz usunąć ten {model}?",
		no_results: "Brak wyników",
	},
	import: "Import",
	export: "Eksport",
	nav: {
		approvals: "Zatwierdzenia",
		codes: "Kody",
		declarations: "Deklaracje",
		items: "Pozycje",
		organisations: "Organizacje",
		invoices: "Faktury",
		documents: "Dokumenty",
		settings: "Ustawienia",
		assistant: "Asystent",

		import: "Import",
		export: "Eksport",
		messages: "Wiadomości",
		audit: "Audyt",
		changelog: "Log zmian",
		inspect: "Inspekcja",
	},
	addresses: {
		model_name: "Adres{{es}}",
		attributes: {
			street: "Ulica i numer domu",
			postcode: "Kod pocztowy",
			place: "Miasto",
		},
	},
	approvals: {
		requested_by: "Wnioskowane przez",
		approved_by: "Zatwierdzone przez",
		invoice_amount: "Wartość faktury",
		payment_amount: "Kwota do zapłaty (UTB)",
	},
	attributes: {
		bill_of_lading: "List przewozowy",
		created_at: "Utworzono",
		date: "Data",
		description: "Opis",
		name: "Nazwa",
		not_applicable: "n/d",
		reference: "Referencja",
		status: "Status",
		updated_at: "Zaktualizowano",
	},
	contracts: {
		model_name: "Umowa{{e}}",
		title: "Umowy",
		links: {
			overview: "Przejdź do przeglądu",
			oldVersion: "Przejdź do starej wersji",
			copyUrl: "Skopiuj URL umowy",
		},
		attributes: {
			locale: "Język tego formularza",
			contract_duration: "Czas trwania umowy",
			contract_language: "Język umowy",
			contract_type: "Rodzaj autoryzacji",
			organisation_type: {
				person: "Osoba fizyczna",
				company: "Firma",
			},
			idCopy: "Kopia dowodu osobistego / NIP",
			start_date: "Data rozpoczęcia",
		},
		contract_types: {
			direct: "Bezpośrednia reprezentacja",
			fiscal: "Reprezentacja podatkowa",
		},
		duration_types: {
			indefinite: "Czas nieokreślony",
			fixed: "Określony czas",
			transaction: "Jednorazowa przesyłka",
		},
		tabs: {
			all: "Wszystkie umowy",
			waitingInfo: "Oczekujące na informacje",
			waitingVerification: "Oczekujące na weryfikację",
			sentSigning: "Wysłane do podpisu",
			completed: "Zakończone",
			expired: "Wygasłe",
		},
		signers: {
			list: {
				contract: "Umowa",
				name: "Imię i nazwisko",
				email: "Email",
			},
		},
		reopen: "Otwórz ponownie",
		updateRelations: "Zaktualizuj relacje organizacji",
		synchronise: "Synchronizuj",
		signOnBehalf: "Podpisz w imieniu Lean Customs B.V.",
		signer: {
			model_name: "Podpisujący{{s}}",
			verified: "Zweryfikowany",
			pending: "Oczekujący",
			rejected: "Odrzucony",
			identificationMethod: "Metoda identyfikacji",
			idCopyDownload: "Pobierz kopię dowodu",
			noDocument: "Nie znaleziono dokumentu",
			email: "Email",
			position: "Stanowisko",
			signedAt: "Podpisano dnia",
			validatedAt: "Zweryfikowano dnia",
			verifiedOn: "Ten podpisujący został zweryfikowany dnia {0}",
			rejectedOn: "Ten podpisujący został odrzucony dnia {0}",
			signed: "Podpisany",
			pendingSignature: "Oczekujący na podpis",
			sendSignRequest: "Wyślij prośbę o podpis cyfrowy mailem",
			statusBadge: {
				verified: {
					all: "Wszyscy zweryfikowani",
					n: "{0} zweryfikowanych",
				},
				pending: {
					all: "Wszyscy oczekujący",
					n: "{0} oczekujących",
				},
				rejected: {
					all: "Wszyscy odrzuceni",
					n: "{0} odrzuconych",
				},
			},
			verifyIn:
				"Ten podpisujący zostanie zweryfikowany w ciągu 4 godzin w godzinach pracy (9:00-17:00), lub następnego dnia. Jeśli chcesz, aby weryfikacja została przeprowadzona teraz, zadzwoń pod numer +31 26 791 1056 w godzinach pracy.",
			verifying: "Trwa weryfikacja tego podpisującego",
			verify: "Zweryfikuj podpisującego",
			reject: "Odrzuć podpisującego",
			delete: "Usuń podpisującego",
			verifyDialog: {
				title: "Czy wszystkie dane są poprawne?",
				content:
					"Czy na pewno chcesz zweryfikować tego podpisującego? Tej operacji nie można cofnąć.",
			},
			deletionDialog: {
				title: "Czy na pewno chcesz usunąć tego podpisującego?",
				content:
					"Czy na pewno chcesz usunąć tego podpisującego? Ta operacja nie może być cofnięta i spowoduje usunięcie podpisującego oraz wszystkich jego dokumentów (kopia dowodu, wyciągi z KRS, itp.).",
			},
			rejectionDialog: {
				title: "Wybierz powód odrzucenia",
				reasons: {
					outdated_coc: {
						label: "Przestarzały wyciąg z KRS",
						content:
							"Wyciąg z KRS jest przestarzały. Prosimy o dostarczenie aktualnego wyciągu z KRS (nie starszego niż 6 miesięcy).",
					},
					missing_coc: {
						label: "Brakujący wyciąg z KRS",
						content:
							"Wyciąg z KRS jest brakujący dla jednej lub więcej firm. Prosimy o załączenie wszystkich wyciągów z KRS do momentu powołania upoważnionej osoby fizycznej (w tym właścicieli podstawowych, jeśli dotyczy). Wyciągi z KRS nie mogą być starsze niż 6 miesięcy.",
					},
					invalid_id: {
						label: "Nieprawidłowa identyfikacja",
						content:
							"Twoja identyfikacja nie jest prawidłowa, proszę rozważyć następujące możliwości:\n\n* Numer dowodu osobistego lub paszportu może nie odpowiadać numerowi, który wprowadziłeś ręcznie.\n* Dowód osobisty lub paszport nie jest już ważny (data ważności wygasła).\n* Wprowadzone imię lub nazwiska nie odpowiadają tym, które znajdują się na dowodzie osobistym lub paszporcie.",
					},
					unauthorized_to_sign: {
						label: "Nieupoważniony do podpisania",
						content:
							"Nie jesteś upoważniony do podpisania tej umowy. Skontaktuj się z osobą upoważnioną do podpisania tej umowy.",
					},
					other: {
						label: "Inny",
						content: "",
					},
				},
				contract_language: "Język umowy: {lang}",
			},
			scrive_status: {
				document_problem: "Problem dokumentu",
				document_draft: "Koncept dokumentu",
				document_canceled: "Dokument anulowany",
				document_timedout: "Dokument przeterminowany",
				document_rejected: "Dokument odrzucony",
				waiting_for_prior_signatures: "Oczekiwanie na poprzednie podpisanie",
				invitation_sent: "Zaproszenie wysłane",
				invitation_delivery_problem: "Problem z dostarczeniem zaproszenia",
				invitation_delivered: "Zaproszenie dostarczone",
				invitation_read: "Zaproszenie przeczytane",
				document_opened: "Dokument otwarty",
				document_deferred: "Dokument odroczony",
				document_signed: "Dokument podpisany",
				document_approved: "Dokument zatwierdzony",
				confirmation_delivery_problem: "Problem z dostarczeniem potwierdzenia",
			},
		},
		support_document: {
			model_name: "Dokument wsparcia{{s}}",
		},
		list: {
			name: "Nazwa",
			requestedBy: "Wniosek od",
			status: "Status",
			email: "Email",
			beta: {
				true: "Beta",
				false: "Stabilna",
			},
			audit: "Audit - Przegląd zmian",
			edit: "Edytuj",
			delete: "Usuń",
			new: "Nowa umowa",
			invite_links: "Linki zaproszeń",
		},
		signingForm: {
			title: "Edytuj autoryzację",
			information: {
				title: "Informacje",
				fields: {
					info: {
						label: "Formularz upoważnienia",
						description: `
<h2 class="text-2xl font-bold mb-2 mt-4">Formularz upoważnienia</h2>
Zamierzasz podpisać formularz upoważnienia do reprezentacji przez Lean Customs B.V.<br>
Musisz być upoważnionym przedstawicielem firmy, aby podpisać ten formularz. Jeśli nie jesteś przedstawicielem, nadal możesz wypełnić ten formularz i przesłać go dalej do przedstawiciela w kroku 4.<br><br>Podpisując ten formularz, zgadzasz się na warunki i postanowienia Lean Customs B.V.<br>Aby uzyskać więcej informacji, odwiedź naszą stronę internetową: <a href='https://www.leancustoms.com'>www.leancustoms.com</a>`,
					},
					duration_type: {
						info: `Czas trwania upoważnienia może być:<ul class="list-disc list-inside">
<li><b>Nieokreślony</b>: upoważnienie jest ważne do czasu odwołania</li>
<li><b>Określony</b>: upoważnienie jest ważne przez określony czas</li>
<li><b>Jednorazowy transport</b>: upoważnienie jest ważne na jednorazowy transport</li>
</ul>`,
						label: "Czas trwania umowy",
						options: {
							indefinite: "Nieokreślony",
							fixed: "Określony",
							transaction: "Jednorazowy transport",
						},
					},
					duration_years: {
						label: "Czas trwania umowy w latach",
					},
					contract_reference: {
						label: "Referencja umowy",
						info: "To jest referencja przesyłki, dla której podpisujesz ten formularz upoważnienia.",
					},
					authorisation_type: {
						label: "Typ upoważnienia",
						options: {
							direct: "Bezpośrednie",
							fiscal: "Fiskalne",
						},
					},
				},
			},
			company: {
				title: "Firma",
				address: "Adres",
				info: {
					organisation_type: "Typ organizacji",
					contract_type: "Typ umowy",
					duration_type: "Czas trwania",
					contract_language: "Język umowy",
					contract_reference: "Referencja umowy",
				},
				fields: {
					organisation_type: {
						label: "Czy reprezentujesz firmę czy osobę prywatną?",
						info: "Jeśli reprezentujesz firmę, potrzebujemy również szczegółów dotyczących firmy oraz potwierdzenia, że jesteś upoważniony do reprezentowania tej firmy.",
						options: {
							company: "Firma",
							person: "Osoba prywatna",
						},
					},
					netherlands: {
						label: "Czy firma znajduje się w Holandii?",
						info: "Jeśli firma nie znajduje się w Holandii, wymagany jest numer Krajowej Izby Handlowej (KvK). Jeśli wybierzesz tę opcję, możesz wyszukać swoją firmę.",
						options: {
							yes: "Tak",
							no: "Nie",
						},
					},
					cocSearch: {
						label: "Wyszukiwanie firmy w Krajowej Izbie Handlowej",
					},
					name: {
						label: "Nazwa",
						info: "Proszę podać nazwę firmy, którą reprezentujesz, lub swoje imię i nazwisko, jeśli reprezentujesz siebie.",
					},
					street: {
						label: "Ulica i numer domu",
					},
					postcode: {
						label: "Kod pocztowy",
					},
					place: {
						label: "Miasto",
					},
					country: {
						label: "Kraj",
					},
					coc_excerpt: {
						label: "Wyciąg z Krajowej Izby Handlowej",
						description: `
<ul class="list-disc px-4">
<li>Wyciągi nie mogą być starsze niż 6 miesięcy</li>
<li>Jeśli dotyczą wyciągów odnoszących się do holdingu, dodaj również wyciąg z holdingu (do momentu wskazania osoby fizycznej)</li>
</ul>
        `,
					},
					truthful: {
						label: "Potwierdzenie",
						description: "Oświadczam, że podane informacje są prawdziwe i kompletne.",
					},
				},
			},

			signer: {
				title: "Sygnatariusz(e)",
				nameErrors: {
					missing_last_name:
						'Wygląda na to, że wprowadziłeś nieznany imię. Proszę o podanie prawidłowego imienia. Jeśli "{0}" to twoje imię, to nie zapomnij o tym ostrzeżeniu.',
					abbreviation_used:
						'Wygląda na to, że wprowadziłeś krótką lub krótszą nazwę. Proszę o podanie prawidłowego imienia. Jeśli twoje imię to "John Doe", to nie zapomnij o tym ostrzeżeniu o wpisaniu "J. Doe" lub "John D." zamiast tego wpisz pełne imię "John Doe". Jeśli "{0}" to twoje imię, to nie zapomnij o tym ostrzeżeniu.',
				},
				fields: {
					signersOverview: {
						label: "Już dodani sygnatariusze",
						description:
							"Poniżsi sygnatariusze zostali już dodani do tego formularza. Możesz dodać kolejnych sygnatariuszy, wypełniając formularz poniżej.",
					},
					addSigner: {
						label: "Dodaj sygnatariusza",
						description:
							"Proszę dodać sygnatariuszy tego formularza. Można dodać kilku sygnatariuszy.",
					},
					powerOfAttorney: {
						label: "Pełnomocnictwo",
						description:
							"Czy posiadasz pełnomocnictwo od firmy do podpisania tego formularza? Jeśli tak, możesz wysłać ten formularz do upoważnionej osoby.",
						options: {
							yes: "Tak, jestem upoważniony",
							no: "Nie, prześlij ten formularz do upoważnionej osoby",
						},
					},
					redirect: {
						label: "Przekierowanie",
						description:
							"Proszę podać adres e-mail upoważnionej osoby, do której chcesz przekierować ten formularz. Wyślemy do niej e-mail z linkiem do wypełnienia tego formularza.<br> Wysłanie tego e-maila zapisze bieżący postęp.",
					},
					name: {
						label: "Imię i nazwisko",
						info: "Proszę podać swoje pełne imię i nazwisko. Możesz dodać kolejnych sygnatariuszy po tej czynności.",
					},
					email: {
						label: "Adres e-mail",
						info: "Proszę podać swój adres e-mail. Otrzymasz link do podpisania tego formularza.",
					},
					position: {
						label: "Stanowisko w firmie",
						info: "Proszę podać swoje stanowisko w firmie.",
					},
					identification_type: {
						label: "Identyfikacja",
						info: "Proszę wybrać metodę identyfikacji, którą chcesz użyć.",
						options: {
							idin: "iDIN (zalecane)",
							id_copy: "Dowód osobisty lub paszport",
						},
					},
					idin: {
						label: "iDIN",
						info: `Z iDIN identyfikujesz się jako osoba, <b>musisz użyć swojego osobistego konta bankowego do tego</b>. iDIN to usługa holenderskich banków, dzięki której możesz zidentyfikować się online za pomocą bezpiecznych i zaufanych narzędzi logowania swojego własnego banku.
<br><br>
iDIN jest obsługiwane przez następujące banki:<br>
<ul>
<li>ABN AMRO</li>
<li>ASN Bank</li>
<li>Bunq</li>
<li>ING</li>
<li>Rabobank</li>
<li>RegioBank</li>
<li>SNS Bank</li>
</ul>
`,
					},
					document_number: {
						label: "Numer dokumentu",
						description:
							"Podaj numer dokumentu twojego dowodu osobistego lub paszportu (minimum 5 znaków).",
					},
					idUpload: {
						label: "Załaduj dowód",
						description: "Załaduj plik PDF lub obraz twojego dowodu osobistego lub paszportu.",
					},
				},
			},
			verify: {
				title: "Weryfikacja",
				fields: {
					signers: {
						label: "Sygnatariusze",
						noSigners: "Nie dodano jeszcze żadnych sygnatariuszy",
						addSigner: "Dodaj sygnatariusza",
					},
					organisation: {
						label: "Szczegóły",
						duration: {
							label: "Czas trwania",
							indefinite: "Czas nieokreślony",
							fixed: "{0} lat",
							transaction: "Dla przesyłki {0}",
						},
					},
				},
			},
			done: {
				success: "Dziękujemy za wypełnienie tego formularza",
				successDescription:
					"Otrzymaliśmy Twój formularz i jak najszybciej go przetworzymy. Wkrótce otrzymasz link do podpisania tej upoważnienia. Dopiero po podpisaniu upoważnienia przez Ciebie umowa stanie się ważna, a my będziemy mogli rozpocząć pracę.",
			},
			whatsNext: {
				title: "Co się stanie dalej?",
				steps: {
					one: {
						title: "Weryfikacja",
						subtitle: "Będziesz weryfikowany przez pracownika Lean Customs B.V.",
					},
					two: {
						title: "Prośba o podpis",
						subtitle: "Otrzymasz e-mail z prośbą o podpis od {0}",
					},
					three: {
						title: "Podpisana umowa",
						subtitle: "Teraz możesz pobrać swoją podpisaną umowę",
					},
				},
				formWasForwarded:
					"Twój formularz został przesłany do {0}. Oni uzupełnią formularz i prześlą go do weryfikacji.",
			},
			errors: {
				vat: {
					title: "Nieprawidłowy lub brakujący numer VAT",
					message: "Proszę podać prawidłowy numer VAT",
				},
				eori: {
					title: "Nieprawidłowy lub brakujący numer EORI",
					message: "Proszę podać prawidłowy numer EORI",
				},
				coc: {
					title: "Nieprawidłowy lub brakujący numer KRS",
					message: "Proszę podać prawidłowy numer KRS",
				},
				name: {
					title: "Nieprawidłowe lub brakujące imię i nazwisko",
					message: "Proszę podać prawidłowe imię i nazwisko",
				},
				street: {
					title: "Nieprawidłowy lub brakujący adres",
					message: "Proszę podać prawidłowy adres",
				},
				postcode: {
					title: "Nieprawidłowy lub brakujący kod pocztowy",
					message: "Proszę podać prawidłowy kod pocztowy",
				},
				place: {
					title: "Nieprawidłowe lub brakujące miejsce",
					message: "Proszę podać prawidłowe miejsce",
				},
				country: {
					title: "Nieprawidłowy lub brakujący kraj",
					message: "Proszę podać prawidłowy kraj",
				},
				organisation_type: {
					title: "Nieprawidłowy lub brakujący typ organizacji",
					message: "Proszę podać prawidłowy typ organizacji",
				},
				duration_type: {
					title: "Nieprawidłowy lub brakujący rodzaj trwania",
					message: "Proszę podać prawidłowy rodzaj trwania",
				},
				contract_reference: {
					title: "Nieprawidłowy lub brakujący numer referencyjny umowy",
					message: "Proszę podać prawidłowy numer referencyjny umowy",
				},
				duration_years: {
					title: "Nieprawidłowy lub brakujący okres trwania w latach",
					message: "Proszę podać prawidłowy okres trwania w latach",
				},
			},
		},
		new: {
			title: "Nowa autoryzacja",
			subtitle: "Utwórz nową autoryzację",
			submit: "Utwórz",
			agent: {
				label: "Agent",
			},
			forwarder: {
				label: "Spedytor",
			},
			intermediary: {
				label: "Pośrednik",
			},
			intermediaries: {
				label: "Pośrednicy",
			},
			organisation_type: {
				label: "Typ organizacji",
				options: {
					company: "Firma",
					person: "Osoba fizyczna",
				},
			},
			contract_type_hint:
				"Przy importowaniu towarów dla firm z UE (ale spoza NL), wymagamy autoryzacji podatkowej do przekazywania VAT.",
			acknowledgement:
				"Przesyłając ten formularz, oświadczam, że podane informacje są prawdziwe i poprawne, a w szczególności: wymienione osoby są upoważnione do podpisania, a wyciągi z Krajowego Rejestru Sądowego potwierdzają te informacje.",
			goingBack:
				"Uwaga: cofając się, stracisz wszelkie wprowadzone lub zmodyfikowane informacje w bieżącym kroku.",
			contract_type: {
				label: "Typ autoryzacji",
				options: {
					direct: "Bezpośrednia",
					fiscal: "Podatkowa",
				},
			},
			duration_type: {
				label: "Typ okresu",
				options: {
					indefinite: "Nieokreślony",
					fixed: "Stały",
					transaction: "Jednorazowa dostawa",
				},
			},
			delivery_types: {
				label: "Kto powinien wypełnić ten formularz?",
				options: {
					direct: "Wypełnij samodzielnie",
					share: "Udostępnij jako link",
					email: "Udostępnij za pomocą e-maila",
				},
			},
			email: {
				label: "E-mail reprezentowanej strony",
			},
			duration: {
				label: "Okres w latach",
			},
			contract_reference: {
				label: "Numer referencyjny umowy",
			},
			contract_language: {
				label: "Język umowy",
			},
			locale: {
				label: "Język formularza",
			},
			errors: {
				yearsAsNumber: "Lata trwania powinny być liczbą dodatnią",
				referenceIsEmpty: "Referencja przesyłki nie może być pusta",
				missingDocumentCopy:
					"Niektórzy z podpisowników nie posiadają kopii swojego ID lub paszportu. Przejdź z powrotem i popraw to.",
				someNumbersAreInvalid:
					"Niektóre numery VAT, EORI lub Izby Handlowej są nieprawidłowe lub nie zakończyliśmy jeszcze ich weryfikacji. Proszę poprawić nieprawidłowe numery lub poczekać na zakończenie weryfikacji (powinna zakończyć się automatycznie w ciągu kilku minut).",
			},
			chamberOfCommerceHelp:
				"Więcej informacji można znaleźć w rejestrze firm lokalnych: <a href='{0}' class='underline' target='_blank'>klikając tutaj</a>.",
			chamberOfCommerceRegister:
				"Aby uzyskać więcej informacji, odwiedź <a href='https://ebra.be/'>European Business Registry Association</a>.",
		},
		details: {
			directTitle: "Reprezentacja bezpośrednia",
			fiscalTitle: "Reprezentacja fiskalna",
			representation: "Reprezentacje umów",
			forwarded: {
				title: "Przekazano drogą mailową",
				body: "Ta umowa została przekazana drogą mailową do reprezentowanej strony",
			},
			share: {
				title: "Udostępnij tę umowę",
				body: "Udostępnij link do tej umowy reprezentowanej stronie",
			},
			agent: "Agent / Pełnomocnik",
			requestedBy: "Zażądane przez",
			reference: "Referencja przesyłki",
			duration: "Czas trwania umowy",
			durationDetails: {
				indefinite: "Czas nieokreślony",
				fixed: "{0} lata",
				transaction: "Dla przesyłki {0}",
			},
			representing: "Reprezentacja",
			organisationType: {
				company: "Firma",
				person: "Osoba fizyczna",
			},
			numbers: {
				eori: "Numer EORI",
				vat: "Numer VAT",
				coc: "Numer Krajowej Izby Gospodarczej",
			},
			chamberOfCommerceExerpt: "Wyciąg z Krajowej Izby Gospodarczej",
			signers: "Podpisujący",
			noSigners: "Nie dodano jeszcze żadnych podpisujących",
			status: {
				open: "Oczekujący na informacje",
				information_complete: "Oczekujący na weryfikację",
				document_sent: "Wysłane do podpisania",
				signed_by_represented: "Podpisane przez reprezentowaną stronę",
				completed: "Zakończone",
				expired: "Wygasłe",
			},
			informationStage: {
				company_details: "Szczegóły firmy",
				address_details: "Szczegóły adresu",
				signers: "Informacje o podpisujących",
				pending_verification: "Prześlij",
			},
			signatureStage: {
				noneSigned: "Brak podpisanych klientów",
				someSigned: "{0}/{1} klient(ów) podpisanych",
				allSigned: "Wszyscy klienci podpisani",
			},
			parties: "Strony",
			organizationRole: {
				forwarder: "Spedytor",
				intermediary: "Pośrednik",
			},
		},
		submitForVerification: "Prześlij do weryfikacji",
		verificationDisclaimer:
			"Oświadczam, że powyższe informacje są prawdziwe: wymienione osoby są upoważnione do podpisania, a wyciąg(i) z Krajowej Izby Gospodarczej potwierdzają te informacje.",
		invite_links: {
			noResults: {
				title: "Brak linków zaproszeń",
				description: "Utwórz nowe linki zaproszeń.",
			},
			validUntil: "Ważne do: {date|datetime}",
			newLink: "Nowy link",
			newForm: {
				title: "Utwórz nowy link",
				reference: "Referencja",
				agent: "Agent",
				validFor: "Ważny przez",
				days: "dni",
				createButton: "Utwórz",
			},
		},
		signhost_transaction: {
			status: {
				"0": "Nieznany",
				"5": "Oczekiwanie na dokument",
				"10": "Oczekiwanie na podpisującego",
				"20": "W toku",
				"30": "Podpisane",
				"40": "Odrzucone",
				"50": "Wygasło",
				"60": "Anulowane",
				"70": "Nieudane",
			},
		},
	},
	goods_codes: {
		chapter: "Rozdział",
		section: "Sekcja",
		sdu: "SDU",
		title: "Kody towarów",
		enterToSearch: "Wciśnij Enter aby wyszukać",
		searchHint: "Wyszukaj Wciśnij S",
		searching: "Wyszukiwanie...",
		noResults: "Nie znaleziono kodów towarów",
		error: "Wystąpił błąd podczas ładowania kodów towarów",
		treeView: "Drzewo",
		listView: "Lista",
		details: {
			error: "Nie można znaleźć kodu towaru",
		},
		countryFilter: "Filtruj kraje (Shift + C)",
	},
	measures: {
		exclusions: "Wyłączenia kraje",
	},
	certificates: {
		model_name: "Zaświadczenie{{a}}",
		code: "Kod zaświadczenia",
		identification: "Identyfikacja",
	},
	declarations: {
		model_name: "Deklaracja{{e}}",
		clearance_date: "Data odprawy",
		duties: "Cła",
		mrn: "MRN",
		release_date: "Data zwolnienia",
		vat: "VAT",
		sum_invoice_amount: "Kwota faktury (suma pozycji)",
		template: "Szablon",
		new: {
			button: "Nowa deklaracja",
			shortcut: "Utwórz nową deklarację",
			title: "Utwórz nową deklarację z",
			noTemplate: "Brak szablonu",
		},
		attributes: {
			agent: "Agent",
			agent_function_code: "Funkcja agenta",
			agent_is_payer: "Użyj zabezpieczenia agenta",
			arrival_transport: "Środek transportu po przyjeździe",
			booking_number: "Numer rezerwacji",
			border_transport: "Aktywne środki transportowe graniczne",
			buyer: "Kupujący",
			certificates: "Certyfikaty",
			consignee: "Odbiorca",
			customs_office: "Biuro celne",
			declarant: "Deklarant",
			declaration_type: "Rodzaj deklaracji",
			departure_transport: "Środek transportu na wyjściu",
			departure_transport_nationality: "Narodowość środka transportu na wylocie",
			destination_country_code: "Kod kraju docelowego",
			dispatch_country_code: "Kraj wysyłki",
			exit_office: "Biuro celne wyjścia",
			exportation_country_code: "Kraj eksportowy",
			exporter: "Eksporter",
			fiscal_representative: "Przedstawiciel podatkowy",
			forwarder: "Spedytor",
			goods_location: "Lokalizacja towarów",
			goods_location_country_code: "Kod kraju lokalizacji",
			goods_location_identification_type_code: "Typ identyfikacji lokalizacji",
			goods_location_postcode: "Kod pocztowy lokalizacji",
			goods_location_street_number: "Numer domu lokalizacji",
			goods_location_type_code: "Typ lokalizacji",
			gross_weight: "Całkowita masa brutto",
			guarantee_provider: "Osoba udzielająca gwarancji (13 20 000 000)",
			importer: "Importujący",
			incoterm: "Incoterm",
			incoterm_country_code: "Kraj warunków dostawy",
			incoterm_location: "Miejsce warunków dostawy",
			incoterm_locode: "UN/LOCODE warunków dostawy",
			incoterm_place: "Miejsce warunków dostawy",
			invoice: "Faktura",
			invoice_amount: "Całkowita kwota faktury",
			invoice_currency: "Waluta faktury",
			invoice_date: "Data faktury",
			invoice_number: "Numer faktury",
			invoice_to: "Faktura do",
			net_weight: "Całkowita masa netto",
			package_description: "Znaki wysyłkowe",
			package_type: "Typ opakowania",
			packaging: "Opakowanie",
			payment: "Płatność",
			procedure_current: "Procedura żądana",
			procedure_previous: "Poprzednia procedura",
			procedure_special: "Dodatkowa procedura",
			reference: "Referencja",
			seller: "Sprzedawca",
			shipment: "Wysyłka",
			ticket_number: "Numer biletu",
			ticket_sequence_number: "Numer sekwencji biletu",
			transaction_nature_code: "Natura transakcji",
			transport_mode: "Środek transportu",
			transport_nationality_code: "Narodowość",
			transport_identification: "Numer identyfikacyjny",
			transport_identification_type_code: "Typ identyfikacji",
			transporter: "Przewoźnik",
			user: "Autor",
			transportation_amount: "Kwota transportu",
			transportation_currency: "Waluta transportu",
			insurance_amount: "Kwota ubezpieczenia",
			insurance_currency: "Waluta ubezpieczenia",
		},
		groups: {
			message_info: {
				header: "Informacje o wiadomości",
				subheader: "w tym kody procedur",
			},
			references: {
				header: "Referencje wiadomości, dokumentów, certyfikatów, uprawnień",
			},
			parties: {
				header: "Strony",
			},
			valuation: {
				header: "Informacje wycenowe / Podatki",
			},
			places: {
				header: "Miejsca / Kraje / Regiony",
				goods: "Lokalizacja towarów",
			},
			customs_offices: {
				header: "Biura celne",
				declaration: "Biuro deklaracji",
				exit: "Biuro celnego wyjścia",
			},
			goods: {
				header: "Identyfikacja towarów",
			},
			transport: {
				header: "Informacje o transporcie",
				subheader: "tryby, środki i sprzęt",
				arrival: "Środki transportu po przyjeździe",
				border: "Aktywne środki transportowe graniczne",
				departure: "Środki transportu na wylocie",
				equipment: {
					header: "Wyposażenie transportowe",
				},
			},
			other: {
				header: "Inne elementy danych",
				subheader: "dane statystyczne, gwarancje, dane związane z taryfą",
				transaction_nature_code: "Natura transakcji",
			},
		},
		noResults: "Nie znaleziono deklaracji",
		header: {
			label: "Etykieta",
			items: "Elementy",
		},
		filters: {
			reference: "Referencja",
			trade_movement: {
				key: "Ruch handlowy",
				import: "Import",
				export: "Eksport",
			},
			declaration_type: "Typ deklaracji",
			status: "Status",
			document_control: "Kontrola dokumentów",
			physical_control: "Fizyczna kontrola",
			label: "Etykieta",
			ticket_number: "Numer biletu",
			incoterm: "Incoterm",
			agent_id: "Agent",
			buyer_id: "Nabywca",
			consignee_id: "Odbiorca",
			declarant_id: "Deklarant",
			exporter_id: "Eksporter",
			fiscal_representative_id: "Reprezentant fiskalny",
			forwarder_id: "Spedytor",
			importer_id: "Importujący",
			transporter_id: "Przewoźnik",
			user_id: "Autor",
			message_type: "Typ wiadomości",
		},
		items: {
			noResults: "Nie znaleziono żadnych pozycji",
			header: {
				goods_code: "Kod towaru",
				description: "Opis",
				customs_value: "Wartość celna",
			},
		},
		messages: {
			noResults: "Nie znaleziono żadnych wiadomości",
			header: {
				type: "Typ",
				created_at: "Utworzono o",
			},
			filters: {
				status: "Status",
			},
		},
	},
	declaration_items: {
		model_name: "Pozycja{{e}}",
		attributes: {
			additional_code2: "Drugi dodatkowy kod",
			additional_code: "Dodatkowy kod",
			customs_value: "Wartość celna",
			description: "Opis towaru",
			duty_amount: "Kwota cła",
			goods_nomenclature_code: "Kod nomenklatury towarowej",
			gross_weight: "Masa brutto",
			national_additional_code: "Krajowy dodatkowy kod",
			net_weight: "Masa netto",
			origin_country_code: "Kod kraju pochodzenia",
			package_count: "Liczba opakowań",
			preference_code: "Kod preferencji",
			quantity: "Ilość",
			vat_amount: "Kwota VAT",
			vat_base: "Podstawa opodatkowania VAT",
		},
	},
	declaration_messages: {
		model_name: "Wiadomość{{e}}",
	},
	fiscal_transactions: {
		model_name: "Transakcja fiskalna{{e}}",
		delivery_address: "Adres dostawy",
		transaction_type: "Typ transakcji",
		transaction_types: {
			import: "Przekazanie własnych towarów",
			union_sales: "Sprzedaż wewnątrzwspólnotowa",
			domestic_sales: "Sprzedaż krajowa",
		},
		errors: {
			no_vat_number: "Brak numeru VAT",
		},
	},
	identifiers: {
		coc_number: "Numer Krajowego Rejestru Sądowego (KRS)",
		eori_number: "Numer EORI",
		rex_number: "Numer REX",
		vat_number: "Numer VAT",
		vat_reverse_charge_applicable: "Zastosowanie odwrotnej płatności VAT (art. 23)",
		vat_reverse_charge_na: "Brak zastosowania odwrotnej płatności VAT",
	},
	invoices: {
		model_name: "Faktura{{e}}",
		direct_send: "Wysyłka i przetwarzanie faktury bezpośrednio",
		customer: "Klient",
		supplier: "Dostawca",
		customer_reference: "Numer referencyjny klienta",
		supplier_reference: "Numer referencyjny dostawcy",
		invoice_to: "Faktura do",
		invoice_number: "Numer faktury",
		invoice_date: "Data faktury",
		lines: "Linie",
		order_number: "Numer zamówienia",
		subtotal: "Suma częściowa",
		total: "Łącznie",
		actions: {
			send_externally: "Utwórz fakturę w systemie integracji",
			process: "Przetwórz fakturę",
			send_email: "Wyślij fakturę e-mailem",
		},
		nav: {
			pending: "Oczekujące",
		},
		balance_types: {
			debit: "Debet",
			credit: "Kredyt",
		},
		billing_types: {
			immediate: "Natychmiastowe",
			consolidated: "Konsolidowane",
		},
		invoice_types: {
			purchase: "Faktura zakupu",
			sales: "Faktura sprzedaży",
		},
		item_types: {
			unknown: "Nieznane",
			duties: "Cła",
			duties_prepaid: "Cła (przedpłacone)",
			vat: "VAT",
			vat_prepaid: "VAT (przedpłacony)",
			dms_import: "Deklaracja importowa",
			dms_export: "Deklaracja eksportowa",
			declaration_transport: "Transport",
			fiscal_representation: "Reprezentacja fiskalna",
			goods_classification_import: "Dodatkowa klasyfikacja towarów (kod HS)",
			goods_classification_export: "Dodatkowa klasyfikacja towarów (kod HS)",
			customs_control_document: "Kontrola dokumentów",
			customs_control_physical: "Kontrola fizyczna",
			customs_fine: "Grzywna celna",
			ic_fictitious: "Dostawa fikcyjna",
			ic_transaction: "Transakcja wewnątrzwspólnotowa",
			other: "Inne",
		},
		status: {
			draft: "Szkic",
			open: "Otwarte",
			processed: "Przetworzone",
		},
		type: {
			regular: "Zwykłe",
			combined: "Połączone",
		},
		messages: {
			sent: "Wysłano do Exact. Proces synchronizacji może zająć minutę.",
		},
		settings: {
			auto_invoice: "Automatyczne fakturowanie",
			free_classifications: "Wolne kody HS",
		},
		auto_invoice: {
			yes: "Tak - po rozliczeniu",
			no: "Nie - ręcznie",
			consolidated: "Tak - konsolidowane",
		},
	},
	invoice_lines: {
		amount: "Kwota",
		item: "Pozycja",
		model_name: "Linia faktury{{e}}",
		price_set_externally: "Cena jest ustalana przez oprogramowanie do księgowości finansowej",
		quantity: "Ilość",
		unit_price: "Cena jednostkowa",
	},
	email_address: "Adres e-mail{{e}}",
	organisation_emails: {
		model_name: "Adresy e-mail do powiadomień{{e}}",
	},
	organisations: {
		model_name: "Organizacja{{e}}",
		attributes: {
			name: "Nazwa",
			type: "Typ organizacji",
			country_code: "Kod kraju",
			street: "Ulica i numer domu",
			postcode: "Kod pocztowy",
			place: "Miasto",
			aeo_number: "Numer AEO",
			coc_number: "Numer Krajowej Izby Gospodarczej",
			vat_number: "Numer VAT",
			eori_number: "Numer EORI",
			rex_number: "Numer REX",
			parent_id: "Organizacja nadrzędna",
			role: "Rola",
		},
		header: {
			name: "Nazwa",
			tags: "Tagi",
		},
		actions: {
			add: "Dodaj nową",
			invite: "Zaproś klienta",
			link_existing: "Połącz istniejącą organizację",
		},
		type: {
			company: "Firma",
			person: "Osoba",
		},
		relations: "Relacje",
		role: {
			agent: "Agent",
			customer: "Klient",
			fiscal_representative: "Przedstawiciel podatkowy",
			forwarder: "Spedytor",
			intermediary: "Pośrednik",
			parent: "Organizacja nadrzędna",
			partner: "Partner",
			representative: "Reprezentant",
			representee: "Reprezentowany",
			self: "Własna",
			subsidiary: "Filia",
			supplier: "Dostawca",
			transporter: "Przewoźnik",
		},
		agent: "Agent",
		country_code: "Kraj",
		fiscal_representative: "Przedstawiciel podatkowy",
		forwarder: "Spedytor",
		transporter: "Przewoźnik",
	},
	relations: {
		model_name: "Relacja{{e}}",
	},
	organisation_email: {
		coe: "COE",
		ead: "EAD",
		export: "Eksport",
		ger: "GER",
		icp: "ICP",
		import: "Import",
		invoice: "Faktura",
		portbase_notify_party: "Powiadomienie Portbase",
		signed_document: "Podpisane dokumenty (bezpośrednie/pełnomocnictwo podatkowe)",
		ttw: "TTW",
		utb: "UTB",
	},
	previous_documents: {
		model_name: "Poprzedni dokument{{y}}",
	},
	assistant: {
		title: "Asystent celny",
		description: "Asystent celny pomaga w pytaniach dotyczących holenderskich procesów celnych.",
		actions: {
			send: "Wyślij",
			clear: "Wyczyść",
			clearAndSend: "Wyczyść i wyślij",
			rerun: "Uruchom ponownie",
		},
		status: {
			in_progress: "Ładowanie...",
			completed: "Gotowy",
			failed: "Wystąpił problem. Spróbuj ponownie Uruchom.",
		},
		roles: {
			user: "Ty",
			assistant: "Asystent",
		},
	},

	feedback: {
		title: "Wyślij opinię",
		description:
			"Tutaj możesz przesłać opinię lub zgłosić błędy deweloperom tej aplikacji. Proszę podaj jak najbardziej szczegółowe informacje.",
		bugReport: "Zgłoś błąd",
		generalFeedback: "Ogólna opinia",
		whatWereYouDoing: "Co robiłeś?",
		whatDidYouExpect: "Czego się spodziewałeś?",
		whatActuallyHappened: "Co tak naprawdę się stało?",
		send: "Wyślij opinię",
	},
	terminals: {
		model_name: "Terminal{{y}}",
	},
	users: {
		model_name: "Użytkownik{{owie}}",
	},
	warehouses: {
		model_name: "Magazyn{{y}}",
	},
	form: {
		invalid_option: "Nieprawidłowa opcja",
		invalid_value: "Nieprawidłowa wartość",
		valid_value: "Poprawne",
		placeholder: "Wybierz opcję",
		required: "To pole jest wymagane",
	},
	shortcuts: {
		goToCodes: "Przejdź do kodów",
		goToDeclarations: "Przejdź do deklaracji",
		goToItems: "Przejdź do pozycji",
		goToMessages: "Przejdź do wiadomości",
		goToOrganisations: "Przejdź do organizacji",
		search: "Skoncentruj się na polu wyszukiwania",
		filter: "Dodaj filtr",
		reset: "Resetuj filtry",
		help: "Pokaż skróty klawiszowe",
		close: "Zamknij okno modalne",
		nextPage: "Następna strona",
		prevPage: "Poprzednia strona",
		list: {
			up: "Wybierz poprzednią pozycję",
			down: "Wybierz następną pozycję",
			home: "Wybierz pierwszą pozycję",
			end: "Wybierz ostatnią pozycję",
			open: "Otwórz wybraną pozycję",
		},
		sections: {
			list: "Lista",
			actions: "Akcje",
			navigation: "Nawigacja",
			other: "Inne",
		},
	},
	time: {
		past: {
			year: "przed {0} rokiem",
			month: "przed {0} miesiącem",
			day: "przed {0} dniem",
			hour: "przed {0} godziną",
			minute: "przed {0} minutą",
			second: "przed {0} sekundą",
		},
		future: {
			year: "za {0} rok",
			month: "za {0} miesiąc",
			day: "za {0} dzień",
			hour: "za {0} godzinę",
			minute: "za {0} minutę",
			second: "za {0} sekundę",
		},
	},
	views: {
		addButton: "Dodaj widok",
		addTitle: "Dodaj widok",
		addMessage: "To spowoduje zapisanie bieżących filtrów jako widok",
		editTitle: "Edytuj widok",
		nameHint: "Nazwa widoku",
		alreadyExists: {
			title: "Widok już istnieje",
			message: "Ten widok już istnieje jako {name}",
		},
		nameEmpty: {
			title: "Nazwa widoku nie może być pusta",
			message: "Proszę podać nazwę dla widoku",
		},
		reset: {
			title: "Resetuj widoki",
			message: "To spowoduje zresetowanie wszystkich widoków do domyślnych widoków",
		},
	},
	notifications: {
		kinds: {
			client_error: "Błąd klienta",
			server_error: "Błąd serwera",
			validation_error: "Błąd walidacji",
		},
	},
	notificationDrawer: {
		title: "Pojemnik z powiadomieniami",
		clearAll: "Wyczyść wszystko",
	},
	general: {
		moreResults: "{0} więcej wyników ...",
		noResults: "Brak wyników",
		useOldVersion: "Użyj starej wersji",
	},
	inspection: {
		actions: {
			inspect: "Inspekcja atrybutu",
			markCorrect: "Oznacz jako poprawne",
			markIncorrect: "Oznacz jako niepoprawne",
		},
		dialog: {
			rejection: {
				title: "Oznacz '{attributeName}' jako niepoprawne",
				instruction: "Wprowadź komentarz dla przyszłej referencji",
				action: "Oznacz jako niepoprawne",
			},
			inspection: {
				title: "Dane inspekcji dla '{attributeName}'",
				markedAs: "Oznaczone jako {marked|{correct: Poprawne, incorrect: Niepoprawne}}",
				by: "Przez {userName} dnia <time>{inspectionDateTime|datetime}</time>",
			},
		},
		error: {
			title: "Nieudana inspekcja",
			message:
				"{0|{unknown_attribute: Nieznany lub nieobsługiwany atrybut, internal_error: Błąd wewnętrzny, *: Nieznany błąd}}",
		},
	},
	cmr: {
		download: "Pobierz CMR",
		exemplars: {
			1: "Przykład 1 - nadawca",
			2: "Przykład 2 - adresata",
			3: "Przykład 3 - przewoźnik",
			4: "Przykład 4 - przewoźnik",
		},
		includeLayout: "Uwzględnij układ",
	},
} satisfies Translation;

export default pl;
